import { render } from "./VimeoVideo.vue?vue&type=template&id=4843a30c"
import script from "./VimeoVideo.vue?vue&type=script&lang=js"
export * from "./VimeoVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__